// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1___490b80e611ed57fa86a","cls2":"Unibrow-cls2___3e6cd22bf1631e0ed5b Unibrow-cls1___490b80e611ed57fa86a"};